import React, { useEffect, useState } from 'react';

export default function RadioCollectionField({ labelText, collectionName, disabled, onChange, items, form }) {
	const [accessionKeys, setAccessionKeys] = useState([]);
	const [filteredItems, setFilteredItems] = useState([]);

	useEffect(() => {
		let keys = [];
		let filteredItems = [];
		if (form && items) {
			items.forEach(item => {
				if (item.accessionKey && form[item.accessionKey]) {
					keys.push(item.accessionKey);
					filteredItems.push(item);
				}
			});
			setAccessionKeys(keys);
			// Only display the items that are present in the form
			setFilteredItems(filteredItems);
			
			// If any of the applicable items are true (selected) and any of the items have valid=false, we need to update all to be valid. This happens when the page is first loaded with saved values
			const selectedItem = filteredItems?.find(item => form[item.accessionKey].value);
			const anyInvalid = filteredItems?.find(item => !form[item.accessionKey].valid);
			if (selectedItem && anyInvalid) {
				const event = {
					stopPropagation: () => { },
					target: {
						dataset: {
							accessionkey: selectedItem.accessionKey,
							relatedaccessionkeys: keys.filter(key => key !== selectedItem.accessionKey).join('|')
						},
						checked: true
					}
				}
				onChange(event);
			}
		}
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [items, form])

	if (!accessionKeys.length || !filteredItems.length) {
		return null;
	}

	const valid = form[filteredItems[0].accessionKey].valid;

	return (
		<div className={'form-group col-md-12' + (valid === false ? ' has-error' : '')}>
			<strong className={valid === false ? 'text-danger' : ''}>
				<em>{labelText}</em>
				<span className="text-danger">*</span>
			</strong>{' '}
			&nbsp; &nbsp;
			{filteredItems
				.map((item) => {
					const value = form[item.accessionKey]?.value;
					const relatedAccessionKeys = accessionKeys.filter(key => key !== item.accessionKey).join('|');
					return (
						<label className="radio-inline" key={item.id}>
							<input
								type="radio"
								name={collectionName}
								id={item.id}
								disabled={disabled}
								onChange={onChange}
								checked={value && value !== 'false'}
								data-accessionkey={item.accessionKey}
								data-relatedaccessionkeys={relatedAccessionKeys}
							/>
							{item.label}
						</label>
					)
				})}
			{valid === false && <span className="validation-message help-block">Please fill out this field.</span>}
		</div>
	);
}
